import ContractDropdownDTO from 'features/contracts/dtos/ContractDropdownDTO';
import FormGroup from 'features/shared/forms/components/FormGroup';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  bindField: any;
  errors: Record<string, string>;
  selfReadingContract?: ContractDropdownDTO;
  editableInputs: boolean;
}

const SelfReadingMeterStates = ({ bindField, errors, selfReadingContract, editableInputs }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;
  
  // helpers
  const isLowTarif = () => {
    if (selfReadingContract?.isSingleRate === false) {
      return true;
    }
  }

  // sub-renders
  const renderGasMeter = () => {
    if (selfReadingContract?.commodityDetail == "GasCustomer") {
      return (
        <div className="col-sm-6 px-2">
          <FormGroup labelText="Stav" inputId="DESC_TMSmOdecStav" validationError={errors["DESC_TMSmOdecStav"]}>
            <div className="input-group">
              <input className="form-control" placeholder={tLabels("selfReadingMeterStates.gasMeterState")} {...bindField("DESC_TMSmOdecStav")} />
              <div className="input-group-append">
                <span className="input-group-text">m<sup>3</sup></span>
              </div>
            </div>
          </FormGroup>
        </div>
      );
    }
  }
  
  const renderElectricityMeterHighTarif = () => {
    if (selfReadingContract?.commodityDetail == "ElectricityCustomer") {
      return (
        <>
          {renderDivider()}
          <div className="col-sm-6 px-2">
            <FormGroup labelText="Stav VT" inputId="DESC_TMSmOdecStavVT" validationError={errors["DESC_TMSmOdecStavVT"]}>
              <div className="input-group">
              <input className="form-control" placeholder={tLabels("selfReadingMeterStates.electricityMeterHighTariffState")} {...bindField("DESC_TMSmOdecStavVT")} />
                <div className="input-group-append">
                  <span className="input-group-text">kWh</span>
                </div>
              </div>
            </FormGroup>
          </div>
        </>
      );
    }
  }
  
  const renderElectricityMeterLowTarif = () => {
    if (selfReadingContract?.commodityDetail === "ElectricityCustomer" && isLowTarif()) {
      return (
        <div className="col-sm-6 px-2">
          <FormGroup labelText="Stav NT" inputId="DESC_TMSmOdecStavNT" validationError={errors["DESC_TMSmOdecStavNT"]}>
            <div className="input-group">
              <input className="form-control" placeholder={tLabels("selfReadingMeterStates.electricityMeterLowTariffState")} {...bindField("DESC_TMSmOdecStavNT")} />
              <div className="input-group-append">
                <span className="input-group-text">kWh</span>
              </div>
            </div>
          </FormGroup>
        </div>
      );
    }
  }

  const renderDivider = () => {
    if (isLowTarif()) {
      return <div className="d-lg-none w-100"></div>;
    }
  }

  // render
  if (editableInputs && selfReadingContract) {
    return (
      <>
        {renderElectricityMeterHighTarif()}
        {renderElectricityMeterLowTarif()}
        {renderGasMeter()}      
      </>
    )
  } else {
    return null;
  }
}

export default SelfReadingMeterStates;
